import React from "react";
import { useRoutes } from "react-router-dom";
import { Provider } from "react-redux";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { store } from "./redux/store";

import routes from "./routes";

import { ThemeProvider } from "./contexts/ThemeContext";
import { LayoutProvider } from "./contexts/LayoutContext";
import { SidebarProvider } from "./contexts/SidebarContext";
import { AuthProvider } from "./contexts/JWTContext";
// import { Notyf } from "notyf";

const App = () => {
  const content = useRoutes(routes);
  // const notyf = new Notyf({
  //   duration: 10000,
  //   position: {
  //     x: "right",
  //     y: "top",
  //   },
  // });
  // const eventSource = new EventSource(
  //   "https://ntfy.sh/m1o3i5ntgeowied1o234ghn2iquerngq/sse"
  // );
  // eventSource.onmessage = (e) => {
  //   console.log(e.data);
  //   const data = JSON.parse(e.data);
  //   notyf.success(data.message);
  // };

  return (
    <HelmetProvider>
      <Helmet titleTemplate="%s | Novi Oglasi" defaultTitle="Novi Oglasi" />
      <Provider store={store}>
        <ThemeProvider>
          <SidebarProvider>
            <LayoutProvider>
              <AuthProvider>{content}</AuthProvider>
            </LayoutProvider>
          </SidebarProvider>
        </ThemeProvider>
      </Provider>
    </HelmetProvider>
  );
};

export default App;
